export default "__VITE_ASSET__ZxinXHA1__"